const cache = {};
const loading = {};

function set(key, value) {
  cache[key] = value;
  delete loading[key];
}

function get(key) {
  return cache[key];
}

function remove(key) {
  delete cache[key];
  delete loading[key];
}

function clear() {
  Object.keys(cache).forEach(key => delete cache[key]);
  Object.keys(loading).forEach(key => delete loading[key]);
}

async function getOrFetch(key, fetcher) {
  if (key in cache) {
    return cache[key];
  } else if (key in loading) {
    return loading[key];
  } else {
    loading[key] = new Promise(resolve => {
      fetcher().then(value => {
        cache[key] = value;
        resolve(value);
        delete loading[key];
      });
    });
    return loading[key];
  }
}

export { set, get, remove, clear, getOrFetch };